/** Minimal placeholder while a lazy route chunk loads. */
export function RouteFallback() {
  return (
    <div className="route-fallback" role="status" aria-live="polite" aria-label="Ładowanie…" />
  );
}
